import { Typography } from '@mui/material'

export default function PageNotFound() {
	return <Typography variant={`h1`}>Page not found</Typography>
}
